<div class="form-group" [ngClass]="additionalGroupClass" [class.opacity-75]="disabled">
    @if (label) {
        @if (label) {
            <label class="d-block"
                   [ngClass]="additionalLabelClass"
                   [class.mb-1]="!hint && !(size === 'sm')"
                   [class.mb-0]="hint"
                   [attr.for]="id">{{ label }}
                @if (isRequiredField) {
                    <sup>*</sup>
                }
            </label>
        }
    }
    @if (hint) {
        <div class="hint mb-1" [innerHTML]="hint"></div>
    }

    <div class="position-relative">
        <input
            class="form-control"
            #input
            [ngClass]="size ? 'form-control-' + size : null"
            [attr.id]="id"
            [disabled]="disabled ? disabled : null"
            [attr.aria-describedby]="ariaDescribedby ? ariaDescribedby : null"
            [attr.placeholder]="placeholder"
            [attr.type]="type"
            [value]="value"
            [class.is-invalid]="!inputControl?.pristine && inputControl?.invalid && ((inputControl?.touched && hasBlur) || preValidate)"
            [class.is-valid]="hasBlur && inputControl?.valid"
            (keydown.enter)="handlePressEnter($event)"
            (blur)="hasBlur = true"
            (change)="handlerChange($event)"
            (keyup)="handlerKeyUp($event)" />

        @if (suffixElement) {
            <button class="form-control-suffix" (click)="handleSuffixClick($event)">
                <ng-content select="[suffix]"></ng-content>
            </button>
        }
        @if (inputControl?.errors && ((inputControl?.touched && hasBlur) || preValidate) && showErrorMessage) {
            <div class="invalid-feedback">
                <span class="invalid-feedback-box">{{ inputControl.errors | validationMessage }}</span>
            </div>
        }
    </div>
</div>
